var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateIcon = function SvgCreateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M11.807 8.22V4.88c0-1.197-.97-2.168-2.168-2.168h-.237c-.487 0-.96-.164-1.343-.466l-.718-.567a2.17 2.17 0 0 0-1.344-.467H2.5a1.5 1.5 0 0 0-1.5 1.5v7.031c0 1.197.97 2.168 2.167 2.168H8.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M11.452 15.035a3.548 3.548 0 1 0 0-7.097 3.548 3.548 0 0 0 0 7.097Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.952 10.18a.5.5 0 0 0-1 0zm-1 2.613a.5.5 0 1 0 1 0zm0-2.613v2.613h1V10.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.758 11.987a.5.5 0 1 0 0-1zm-2.613-1a.5.5 0 0 0 0 1zm2.613 0h-2.613v1h2.613z"
  })));
};
export default SvgCreateIcon;